import script from "./icon-two-tones-element-4.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-two-tones-element-4.vue?vue&type=script&lang=ts&setup=true"

import "./icon-two-tones-element-4.vue?vue&type=style&index=0&id=328e681a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-328e681a"]])

export default __exports__